module.exports = __webpack_public_path__ + "img/letterA.cd0b2dd4.svg";